import logger from "loglevel";
const env = process.env.APP_ENV || process.env.NODE_ENV || "development";
const level = env !== "production" ? "debug" : "info";
logger.setLevel(level);
export default logger;
